import { render, staticRenderFns } from "./addItemReleaseType.vue?vue&type=template&id=4884cb48"
import script from "./addItemReleaseType.vue?vue&type=script&lang=js"
export * from "./addItemReleaseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports